import React from 'react'
import '../style.css'

const RecipeTitle = ({ title = '', subTitle = '' }) => {
  return (
    <div className="recipeFormIntro">
      <h1 className="recipeFormTitle">{title}</h1>
      {subTitle ? <p className="recipeFormSubtitle">{subTitle}</p> : null}
    </div>
  )
}

export default RecipeTitle
